import React, { useState } from "react";
import TitleSectionComponent from "../../../../components/core-components/titleSection";
import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Countdown from "../../../../components/core-components/countdownCard";
import CountdownBgImage from "../../../../assets/images/countdown-bg.webp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { LoadingButton } from "@mui/lab";
import DownloadIcon from "@mui/icons-material/Download";

function Membership() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [loadingBasvuruPdf, setLoadingBasvuruPdf] = useState(false);
  const [loadingBasvuruDocx, setLoadingBasvuruDocx] = useState(false);
  const [loadingUyelik, setLoadingUyelik] = useState(false);

  const handleDownloadBasvuruPdf = async () => {
    setLoadingBasvuruPdf(true);
    setTimeout(() => {
      const link = document.createElement("a");
      link.href = "/Beşiktaşlı Tıbbiyeliler Derneği Başvuru Formu.pdf";
      link.download = "besiktasli-doktorlar-dernegi-basvuru-formu.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoadingBasvuruPdf(false);
    }, 2000);
  };

  const handleDownloadBasvuruDocx = async () => {
    setLoadingBasvuruDocx(true);
    setTimeout(() => {
      const link = document.createElement("a");
      link.href = "/Beşiktaşlı Tıbbiyeliler Derneği Başvuru Formu.docx";
      link.download = "besiktasli-doktorlar-dernegi-basvuru-formu.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoadingBasvuruDocx(false);
    }, 2000);
  };

  const handleDownloadUyelik = async () => {
    setLoadingUyelik(true);
    setTimeout(() => {
      const link = document.createElement("a");
      link.href = "/BJK_Uyelik_Formu.pdf";
      link.download = "BJK_Uyelik_Formu.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoadingUyelik(false);
    }, 2000);
  };

  return (
    <section
      id="membership"
      style={{
        backgroundColor: "var(--bg-color)",
        height: "100%",
        paddingBottom: "100px",
      }}
    >
      <div className="container" style={{
      marginTop: "-55px"}}>
        <TitleSectionComponent titleText="" />
        <Grid container spacing={isMobile ? 2 : 4}>
          {/* Countdown Section - Commented out but preserved */}
          {/* 
          <Grid item xs={12}>
            <Box
              sx={{
                position: "relative",
                color: "#fff",
                textAlign: "center",
                padding: isMobile ? "50px 0" : "100px 0",
                borderRadius: "16px",
              }}
            >
              // ...existing countdown box code...
            </Box>
          </Grid>
          */}

          {/* Fee Information Section - Commented out but preserved */}
          {/* 
          <Grid item xs={12}>
            <Stack spacing={3}>
              <p className="B-18">
                Derneğimize üye olmanın giriş ücreti{" "}
                <span style={{ fontWeight: 700 }}>5.000 TL</span>
                'dir, yıllık aidatlar ise{" "}
                <span style={{ fontWeight: 700 }}>250 TL</span>'dir. Üyelik
                ücretinizi ve ilk yıl için aidatınızı nakit olarak
                ödeyebileceğiniz gibi kredi kartı imkanından da
                faydalanabilirsiniz.
              </p>
              
              <p className="B-18">
                <Stack>
                  <span style={{ fontWeight: 700 }}>
                    Beşiktaş JK Derneği hesap numaramız:
                  </span>
                  <span>Denizbank – Ataşehir Tic. Mrk. Şb.</span>
                  IBAN: TR 51 0013 4000 0009 8546 8000 98
                </Stack>
              </p>
              // ...rest of the commented section...
            </Stack>
          </Grid>
          */}

      
          <Grid item xs={isMobile ? 12 : 6} >
            <TitleSectionComponent
              titleText="Gerekli Evraklar"
              textAlign="left"
            />
            <Stack spacing={3}>
              <span className="B-18" style={{ paddingLeft: "20px" }}>
                <ul style={{ listStyleType: "disc" }}>
                  <li>
                    Tıp veya Diş Hekimliği diploma fotokopisi (e-devletten
                    Yüksek Öğretim Mezun Belgesi de oluşturulabilir)
                  </li>
                  <li>1 vukuatlı nüfus kayıt örneği (e-devletten alınabilir</li>
                  <li>
                    1 adet ikamet edilen mahalle muhtarlığından alınmış
                    ikametgah belgesi (e-devletten ikametgah belgesi alınabilir)
                  </li>
                  <li>
                    1 adet savcılıktan adli sicil belgesi (e-devletten adli
                    sicil belgesi alınabilir)
                  </li>
                  <li>
                    2 adet renkli ve son 6 ay içerisinde çekilmiş vesikalık
                    fotoğraf{" "}
                  </li>
                  <li>
                    Tıp veya Diş Hekimliği Fakültesi öğrencileri için öğrenci
                    belgesi{" "}
                  </li>
                </ul>
              </span>
            </Stack>
          </Grid>
          <Grid item xs={isMobile ? 12 : 6}>
            <TitleSectionComponent
              titleText="Hesap Bilgilerimiz"
              textAlign="left"
            />
            <Stack spacing={1}>
              <p className="B-18">
                <span style={{ fontWeight: 700 }}>Hesap Sahibi: </span>
                BEŞİKTAŞLI TIBBİYELİLER DERNEĞİ
              </p>
              <p className="B-18">
                <span style={{ fontWeight: 700 }}>IBAN: </span>{" "}
                TR490006701000000022956400
              </p>
              <p className="B-18">
                <span style={{ fontWeight: 700 }}>Hesap No: </span> 22956400 TL
              </p>
              <p className="B-18">Yapıkredi Bankası</p>
              <p className="B-18">Açıklama Kısmına isim soyisim yazın lütfen</p>
              <p className="B-18">
                {" "}
                Derneğimizin giriş ücreti 2.500 TL olup yıllık aidatı 2025 yılı
                için 1.500 TL’dir. (Öğrenciler için %50 indirim uygulanacaktır.){" "}
              </p>
            </Stack>
          </Grid>
          <Grid item xs={12}>
         
            <TitleSectionComponent
              titleText="Başvuru ve Üyelik Formları"
              textAlign="left"
              
            />
            <Stack spacing={1} >
              <Grid container spacing={1}>
                <Grid item xs={isMobile ? 12 : 4}>
                  <LoadingButton
                    variant="contained"
                    loading={loadingBasvuruPdf}
                    onClick={handleDownloadBasvuruPdf}
                    loadingIndicator="İndiriliyor..."
                    startIcon={<DownloadIcon />}
                    sx={{
                      width: "100%",
                      backgroundColor: "#333",
                      color: "white",
                      borderRadius: "20px",
                      padding: "5px 20px",
                      height: "80px",
                      textTransform: "capitalize",
                      "&:hover": { backgroundColor: "#000" },
                    }}
                  >
                    <span className="B-18" style={{ color: "#fff" }}>
                      Beşiktaşlı Tıbbiyeliler Derneği Başvuru Formu (PDF)
                    </span>
                  </LoadingButton>
                </Grid>
                <Grid item xs={isMobile ? 12 : 4}>
                  <LoadingButton
                    variant="contained"
                    loading={loadingBasvuruDocx}
                    onClick={handleDownloadBasvuruDocx}
                    loadingIndicator="İndiriliyor..."
                    startIcon={<DownloadIcon />}
                    sx={{
                      width: "100%",
                      backgroundColor: "#333",
                      color: "white",
                      borderRadius: "20px",
                      padding: "5px 20px",
                      height: "80px",
                      textTransform: "capitalize",
                      "&:hover": { backgroundColor: "#000" },
                    }}
                  >
                    <span className="B-18" style={{ color: "#fff" }}>
                      Beşiktaşlı Tıbbiyeliler Derneği Başvuru Formu (DOCX)
                    </span>
                  </LoadingButton>
                </Grid>
                <Grid item xs={isMobile ? 12 : 4}>
                  <LoadingButton
                    variant="contained"
                    loading={loadingUyelik}
                    onClick={handleDownloadUyelik}
                    loadingIndicator="İndiriliyor..."
                    startIcon={<DownloadIcon />}
                    sx={{
                      width: "100%",
                      backgroundColor: "#333",
                      color: "white",
                      borderRadius: "20px",
                      padding: "5px 20px",
                      height: "80px",
                      textTransform: "capitalize",
                      "&:hover": { backgroundColor: "#000" },
                    }}
                  >
                    <span className="B-18" style={{ color: "#fff" }}>
                      BJK Üyelik Formu (PDF)
                    </span>
                  </LoadingButton>
                </Grid>
              </Grid>

              <p className="B-18">
                Evraklarınızı info@besiktaslitibbiyeliler.org adresine mail
                atabilir veya kargo ile asıllarını Dr. Ali KILIÇ adına aşağıdaki
                adrese gönderebilirsiniz.
              </p>
              <p className="B-18">
              Metropol İstanbul, Atatürk, Ertuğrul Gazi Sk. No:2E A2 Blok D:452, 34758 Ataşehir/İstanbul
               </p>
            </Stack>
          </Grid>
          <Grid item xs={isMobile ? 12 : 6}>
            <TitleSectionComponent
              titleText="Nasıl Referans Bulabilirim?"
              textAlign="left"
            />
            <p className="B-18">
            BJK Kongre Üyesi Hekimlerden referans istenilmemektedir. Kongre üyesi olmayanlar dernek üyelerimiz vasıtası ile referans bulabilirler
            </p>
          </Grid>
          <Grid item xs={isMobile ? 12 : 6}>
            <TitleSectionComponent
              titleText="Ücret Yatırılmalı mı?"
              textAlign="left"
            />
            <p className="B-18">
            Giriş aidatını yatırmalısınız. Yıllık aidatı yıl içinde herhangi bir zaman ödeyebilirsiniz
            </p>
          </Grid>
          <Grid item xs={12}   >
            <TitleSectionComponent
              titleText="E-Devlet ile Üyelik"
              textAlign="center"
            />
            <Stack spacing={3}>
              <p className="B-18">
                Derneğimize elektronik imzası olan üye adaylarımız E-Devlet ile
                online başvuru yapabilirler.
              </p>
              <p className="B-18">
                Sistem sadece iki evrak yüklenmesini kabul ettiği için gereken
                evrakları tek PDF yaparak yüklemeniz işlemleri hızlandıracaktır.
              </p>
              <p className="B-18">
                Son 6 ayda çekilmiş fotoğrafınızı da yüklemenizi rica ederiz.
                Evrak ve Fotoğrafınızı mail yolu ile de iletebilirsiniz.
              </p>
              <p className="B-18">Dikkat Edilmesi Gerekenler!</p>
              <span className="B-18" style={{ paddingLeft: "20px" }}>
                <ul style={{ listStyleType: "disc" }}>
                  <li>
                    E-Devlete <span style={{ fontWeight: 700 }}>E-İmza </span>
                    ile giriş yapılmalı
                  </li>
                  <li>
                    Dernek Kütük Numaramız:{" "}
                    <span style={{ fontWeight: 700 }}>34286081</span>
                  </li>
                  <li>
                    1 adet Savcılık'tan{" "}
                    <span style={{ fontWeight: 700 }}>Adli Sicil Belgesi</span>
                  </li>
                  <li>
                    Dernek Adı:{" "}
                    <span style={{ fontWeight: 700 }}>
                      BEŞİKTAŞLI TIBBİYELİLER DERNEĞİ
                    </span>{" "}
                    (Büyük Harf kullanılmalı)
                  </li>
                </ul>
              </span>
              <Button
                variant="contained"
                endIcon={<ArrowForwardIcon style={{ marginLeft: "16px" }} />}
                sx={{
                  mt: 4,
                  width: "100%",
                  backgroundColor: "var(--black-primary)",
                  color: "var(--white-color)",
                  borderRadius: "20px",
                  padding: "5px 20px",
                  height: "50px",
                  textTransform: "capitalize",
                  "&:hover": { backgroundColor: "var(--black-color)" },
                }}
                onClick={() =>
                  window.open(
                    "https://www.turkiye.gov.tr/icisleri-dernek-uyelik-basvurusu",
                    "_blank"
                  )
                }
                
              >
                <span className="B-18" style={{ color: "var(--white-color)" }} >
                  E-devlet İle Başvur
                </span>
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </div>
    </section>
  );
}

export default Membership;
